module.exports = __webpack_public_path__ + "img/fuwuhao.f12fcbcf.jpg";